<template>
  <el-affix>
  <HomeHead />
  </el-affix>
  <router-view></router-view>
  <div style="background-color: #F6F4E7;">
  <Bottom v-if="!isBottomVisible" />
  </div>
</template>

<script>
import HomeHead from './components/HomeHead.vue'
import Bottom from './components/BottomPic.vue'

export default {
  name: 'App',
  components: {
    HomeHead,
    Bottom
  },
  computed: {
    isBottomVisible() {
      // 根据路由路径判断是否显示 Bottom 组件
      return this.$route.path === '/tongji-china/integratedhumanpractice'; // 替换为你的路由路径
    },
  },
}
</script>

<style lang="less">
  @import url("@/assets/fonts/fonts.css");

  .el-loading-spinner .circular{
  width: 42px;
  height: 42px;
  animation: loading-rotate 2s linear infinite;
  display: none;
}

.el-loading-spinner{

  /* 图片替换为你自定义的即可 */
  background: url(https://static.igem.wiki/teams/5298/assets/loading.gif) no-repeat;
  background-size: 45vw 28vw;
  width: 100%;
  height: 100%;
  background-position:center;
  top:0;
}

.el-loading-spinner .el-loading-text{
  /*为了使得文字在loading图下面*/
  color: #DA6CA5;
  font-family: 'LOGO',sans-serif !important;
  font-size: 25px;
  margin-top:67vh;
}

/* 隐藏浏览器自带的滚动条 */
body::-webkit-scrollbar {
  width: 10px; /* 调整滚动条宽度 */
}
 
body::-webkit-scrollbar-track {
  background-color: #ffffffe3; /* 设置滚动条轨道背景色为透明 */
}
 
body::-webkit-scrollbar-thumb {
  background-color: rgba(138, 128, 128, 0.2); /* 设置滚动条滑块颜色 */
  border-radius: 0.25em; /* 设置滚动条滑块圆角 */
}
 
/* 显示页面内的滚动条 */
.scrollable-content {
  overflow-y: auto; /* 启用垂直滚动条 */
}
</style>
